// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"adda88d8","787":"22f0931b"}[chunkId] + ".chunk.js";
};